import { useState, ReactElement } from "react";
import { useI18n } from "i18n";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { StarBorderRounded } from "@remo-co/ui-core/src/icons/StarBorderRounded";
import { StarRounded } from "@remo-co/ui-core/src/icons/StarRounded";
import { RatingType } from "modules/guestExperienceSurvey/constants";
import { useStyles } from "./styles";

interface Props {
  onSelect: (rating: RatingType) => void;
}

const ratings: RatingType[] = [1, 2, 3, 4, 5];

const Rating = ({ onSelect }: Props): ReactElement => {
  const [rating, setRating] = useState<RatingType>(0);
  const [selected, setSelected] = useState(false);
  const classes = useStyles();
  const { t } = useI18n(["auth", "event"]);

  const resetRanking = () => {
    if (selected) {
      return;
    }
    setRating(0);
  };

  const previewRating = (value: RatingType) => {
    if (!selected) {
      setRating(value);
    }
  };

  return (
    <>
      <Container
        flex
        justifyContent="space-between"
        className={classes.starsContainer}
        onMouseOut={resetRanking}
      >
        {ratings.map((value) =>
          rating >= value ? (
            <StarRounded
              className={classes.starSelected}
              titleAccess={`${value}`}
              data-testid={`selected-rating-${value}`}
              onClick={() => {
                setRating(value);
                setSelected(true);
              }}
              key={value}
            />
          ) : (
            <StarBorderRounded
              className={classes.star}
              titleAccess={`${value}`}
              data-testid={`rating-${value}`}
              onMouseOver={() => previewRating(value)}
              onClick={() => {
                setRating(value);
                setSelected(true);
              }}
              key={value}
            />
          ),
        )}
      </Container>
      <Container flex justifyContent="space-between">
        <Typography variant="caption" className={classes.ratingText}>
          {t("event:guest.survey.negative")}
        </Typography>
        <Typography variant="caption" className={classes.ratingText}>
          {t("event:guest.survey.positive")}
        </Typography>
      </Container>
      {selected && (
        <Container
          flex
          justifyContent="flex-end"
          className={classes.submitContainer}
        >
          <Button
            variant="secondary"
            color="blue"
            size="md"
            onClick={() => onSelect(rating)}
          >
            {t("submit")}
          </Button>
        </Container>
      )}
    </>
  );
};

export default Rating;
